import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { StyleSheet, css } from 'aphrodite'
import { BP_XS } from '../../lib/breakpoints'
import { useAnchorAutoScroll } from '../../utils/Utils'
import UILink from '../../components/UI/UILink'
import UILogo from '../../components/UI/UILogo'
import Landscape from './Landscape'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
  },
  subContainerLeft: {
    paddingTop: 150,
    paddingLeft: 100,
    width: '60%',
  },
  paragraph: {
    paddingTop: 50,
  },
  li: {
    paddingTop: 10,
  },
  listTitle: {
    paddingTop: 10,
    paddingBottom: 10,
  },
  welcome: {
    width: '100%',
    textAlign: 'center',
  },
  subContainerLeftMobile: {
    paddingTop: 50,
    paddingLeft: 20,
    paddingRight: 20,
    width: '100%',
  },
  paragraphMobile: {
    fontSize: 18,
    fontWeight: 'bolder',
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  logo: {
    width: 180,
  },
  containerSite: {
    display: 'flex',
    flexDirection: 'row',
  },
})

const PageNotFound = () => {
  const { t } = useTranslation('translation')
  useAnchorAutoScroll()
  return (
    <div className={css(styles.container)}>
      {window.innerWidth < BP_XS ? (
        <div>
          <div className={css(styles.subContainerLeftMobile)}>
            <UILogo
              dynamicStyle={styles.logoContainer}
              logoStyle={styles.logo}
            />
            <div className={css(styles.paragraphMobile)}>
              <p>{t('pages.notFound.description')}</p>
              <p className={css(styles.listTitle)}>
                {t('pages.notFound.listTitle')}
              </p>
              <ul>
                <li className={css(styles.li)}>
                  {t('pages.notFound.listElement1')}
                  <UILink
                    linkTitle={t('pages.notFound.listElement1Link')}
                    redirection="/"
                    linkStyle="simple"
                    target="_self"
                  />
                </li>
                <li className={css(styles.li)}>
                  {t('pages.notFound.listElement2')}
                  <UILink
                    linkTitle={t('pages.notFound.listElement2Link')}
                    redirection="/be-a-viewer"
                    linkStyle="simple"
                    target="_self"
                  />
                </li>
                <li className={css(styles.li)}>
                  {t('pages.notFound.listElement3')}
                  <UILink
                    linkTitle={t('pages.notFound.listElement3Link')}
                    redirection="/create-request"
                    linkStyle="simple"
                    target="_self"
                  />
                </li>
                <li className={css(styles.li)}>
                  {t('pages.notFound.listElement4')}
                  <UILink
                    linkTitle={t('pages.notFound.listElement4Link')}
                    redirection="/be-a-maker"
                    linkStyle="simple"
                    target="_self"
                  />
                </li>
              </ul>
              <p>{t('pages.notFound.goodExperience')}</p>
              <p>{t('pages.notFound.ubiqEyesTeam')}</p>
            </div>
          </div>
        </div>
      ) : (
        <div className={css(styles.containerSite)}>
          <Landscape />
          <div className={css(styles.subContainerLeft)}>
            <h1 className={css(styles.welcome)}>
              {t('pages.notFound.welcome')}
            </h1>
            <div className={css(styles.paragraph)}>
              <p>{t('pages.notFound.description')}</p>
              <p className={css(styles.listTitle)}>
                {t('pages.notFound.listTitle')}
              </p>
              <ul>
                <li className={css(styles.li)}>
                  {t('pages.notFound.listElement1')}
                  <UILink
                    linkTitle={t('pages.notFound.listElement1Link')}
                    redirection="/"
                    linkStyle="simple"
                    target="_self"
                  />
                </li>
                <li className={css(styles.li)}>
                  {t('pages.notFound.listElement2')}
                  <UILink
                    linkTitle={t('pages.notFound.listElement2Link')}
                    redirection="/be-a-viewer"
                    linkStyle="simple"
                    target="_self"
                  />
                </li>
                <li className={css(styles.li)}>
                  {t('pages.notFound.listElement3')}
                  <UILink
                    linkTitle={t('pages.notFound.listElement3Link')}
                    redirection="/create-request"
                    linkStyle="simple"
                    target="_self"
                  />
                </li>
                <li className={css(styles.li)}>
                  {t('pages.notFound.listElement4')}
                  <UILink
                    linkTitle={t('pages.notFound.listElement4Link')}
                    redirection="/be-a-maker"
                    linkStyle="simple"
                    target="_self"
                  />
                </li>
              </ul>
              <br></br>
              <p>{t('pages.notFound.goodExperience')}</p>
              <p>{t('pages.notFound.ubiqEyesTeam')}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

PageNotFound.propTypes = {
  elementToScroll: PropTypes.element,
  scroll: PropTypes.bool,
}

export default PageNotFound
